<template>
    <div class="card">
        <div class="card-header">
            <div class="d-flex flex-row mt-2 ml-2 mb-2 mr-0">
                <a :href="categoriesIndexRoute" class="btn btn-secondary btn-sm mr-1" role="button"
                    ><i class="fa fa-arrow-left" aria-hidden="true"></i>
                </a>
                <a
                    href="javascript:void(0)"
                    class="btn btn-primary btn-sm"
                    role="button"
                    @click="update"
                    >{{ trans.btn.update }}
                </a>
            </div>
        </div>
        <div class="card-body p-2">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr class="table-header-center">
                        <th>{{ trans.id }}</th>
                        <th>{{ trans.images }}</th>
                        <th>{{ trans.title }}</th>
                        <th>{{ trans.action }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(cate, index) in categories" :key="index">
                        <td class="text-center align-middle">{{ cate.id }}</td>
                        <td class="text-center"><img :src="cate.icon_url" class="icon-size-60"></td>
                        <td class="text-center align-middle">{{ cate.title }}</td>
                        <td class="text-center align-middle">
                            <a
                                class="btn btn-outline-secondary"
                                role="button"
                                @click="swapCustomField('up', index)"
                                :class="{ disabled: index == 0 }"
                            >
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </a>
                            <a
                                class="btn btn-outline-secondary"
                                role="button"
                                @click="swapCustomField('down', index)"
                                :class="{ disabled: index == categories.length - 1 }"
                            >
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        categoriesResource: {
            type: Array,
            default: function () {
                return [];
            }
        },
        trans: {
            type: Object,
            required: true
        },
        formAction: {
            type: String,
            required: true
        },
        categoriesIndexRoute: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            categories: this.categoriesResource,
        };
    },
    methods: {
        swapCustomField(move, index) {
            var startDeleteAt;
            var elements;
            switch (move) {
                case 'up':
                    if (index == 0) return;
                    startDeleteAt = index - 1;
                    elements = [this.categories[index - 1], this.categories[index]];
                    break;
                case 'down':
                    if (index == this.categories.length - 1) return;
                    startDeleteAt = index;
                    elements = [this.categories[index], this.categories[index + 1]];
                    break;

                default:
                    return;
            }
            this.categories.splice(startDeleteAt, 2, elements[1], elements[0]);
        },
        update() {
            var ids = [];
            var sort = [];
            this.categories.forEach((cate, index) => {
                ids.push(cate.id);
                if (this.currentPage > 1) {
                    index += ((this.currentPage - 1) * 10) + 1; 
                }
                sort.push(index);
            });
            axios({
                method: 'PUT',
                url: this.formAction,
                data: {
                    ids,
                    sort
                }
            })
                .then((response) => {
                    if (response.data.redirectTo != undefined) {
                        window.location.replace(response.data.redirectTo);
                    } else {
                        location.reload();
                    }
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        this.errors = error.response.data.errors;
                    }
                });
        },
    }
};
</script>